import { NgModule, ModuleWithProviders } from '@angular/core';
import { AuthorizatorService } from './services/authorizator.service';
import { AuthorizatorConfig } from './authorizator.config';
import { AUTHORIZATOR_CONFIG } from './authorizator.config.token';
import { PermissionManagerComponent } from './components/permission-manager/permission-manager.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from '@angular/common';
import { AngularFirebaseAuthotizatorComponent } from './components/angular-firebase-authotizator/angular-firebase-authotizator.component';
import { UsersComponent } from './components/users/users.component';
import { UpsertUserComponent } from './components/users/upsert-user/upsert-user.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeleteUserWarningComponent } from './components/users/delete-user-warning/delete-user-warning.component';
import { RolesComponent } from './components/roles/roles.component';
import { DeleteRoleWarningComponent } from './components/roles/delete-role-warning/delete-role-warning.component';
import { UpsertRoleComponent } from './components/roles/upsert-role/upsert-role.component';
import { ProgressbarService } from './services/progressbar.service';

@NgModule({
  declarations: [
    PermissionManagerComponent, AngularFirebaseAuthotizatorComponent,
    UsersComponent, UpsertUserComponent, DeleteUserWarningComponent,
    RolesComponent, DeleteRoleWarningComponent, UpsertRoleComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatGridListModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatIconModule,
    MatTabsModule,
    MatTableModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    MatSnackBarModule,
    MatProgressBarModule
  ],
  exports: [AngularFirebaseAuthotizatorComponent],
  providers: [AuthorizatorService, ProgressbarService],
  entryComponents: [
    UpsertUserComponent, DeleteUserWarningComponent,
    UpsertRoleComponent, DeleteRoleWarningComponent,
    PermissionManagerComponent
  ]
})
export class AngularFirebaseAuthorizatorModule {
  static forRoot(authorizatorConfig: AuthorizatorConfig): ModuleWithProviders {
    return {
      ngModule: AngularFirebaseAuthorizatorModule,
      providers: [
        {
          provide: AUTHORIZATOR_CONFIG,
          useValue: authorizatorConfig
        }
      ]
    };
  }
}
